module.exports = __webpack_public_path__ + "static/media/scr3.b52bf1e1.png";